import { render, staticRenderFns } from "./NewsletterGroup.vue?vue&type=template&id=053388e3&scoped=true"
import script from "./NewsletterGroup.vue?vue&type=script&lang=js"
export * from "./NewsletterGroup.vue?vue&type=script&lang=js"
import style0 from "./NewsletterGroup.vue?vue&type=style&index=0&id=053388e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053388e3",
  null
  
)

export default component.exports